import React from 'react';

import styles from './CompetitionsPage.module.css';

type Props = {
  children: React.ReactNode;
};

export const CompetitionsPageRightSection: React.FC<Props> = ({ children }) => (
  <div className={styles.CompetitionsPage__RightSection}>{children}</div>
);
